<template>
    <div id="create-case-pms-main-button" class="align-items-center clickable my-3" @click="showCreateCasePMS()">
        <span class="font-weight-bold primary--text float-right btn-lg-primary">
            Create Case from PMS
        </span>
    </div>
</template>

<script>
import DASHBOARD_STORE from "../store/dashboard.module";

export default {
    methods: {
        showCreateCasePMS() {
            console.log("resetting of search data");

            // making sure the selected items are always empty on each load
            DASHBOARD_STORE.commit("setSeachItems", []);

            // making sure that search string is always empty
            DASHBOARD_STORE.commit("setCaseSearch", "");

            // make sure the selected search data is reset
            DASHBOARD_STORE.commit("setSelectedSearchCase", null);
            DASHBOARD_STORE.commit("setSelectedPatient", {});
            DASHBOARD_STORE.commit("setIsImagesRetrieved", false);
            

            // showing create case modal
            DASHBOARD_STORE.commit("showCreateCasePMS", true);
        }
    },

    computed: {
        selectedPatient: {
            get() { return DASHBOARD_STORE.getters['showSelectedPatient'] },
            set(val) { DASHBOARD_STORE.commit('setSelectedPatient', val) }
        },
    },
}
</script>

<style lang="scss" scoped>
    .btn-lg-primary {
            padding: 10px 25px;
        background: #258bf5;
        border-radius: 5px;
        color: #fff !important;
    }
</style>